import { FetchUsageResponse } from "@shared/types/localTypes/usage-explorer.ts";
import { CONSUMPTION_GROUP_BY_DIMENSIONS_BY_STORAGE_TYPE } from "@shared/components/usage-explorer/storage-type-picker/helper.ts";
import { ConsumptionCsvGroupBy } from "@shared/services/usage-explorer/fetchConsumptionCsv.ts";
import isTourConsumptionRequest from "@shared/services/tour/mockedApis/usageExplorer/is-tour-consumption-request.ts";
import buildTourConsumptionMonths from "@shared/services/tour/mockedApis/usageExplorer/build-tour-consumption-months.ts";
import aggregateTourConsumptionPeriod from "@shared/services/tour/mockedApis/usageExplorer/aggregate-tour-consumption-period.ts";
import toTourConsumptionTopItem from "@shared/services/tour/mockedApis/usageExplorer/to-tour-consumption-top-item.ts";

type TourConsumptionGetDashboardData = (
  data?: object,
) => Promise<FetchUsageResponse>;

const tourConsumptionGetDashboardData: TourConsumptionGetDashboardData = async (
  data,
) => {
  if (!isTourConsumptionRequest(data)) {
    throw new Error(
      `Unsupported tour consumption request '${JSON.stringify(data)}'`,
    );
  }
  const months = buildTourConsumptionMonths({ request: data });
  const groupBys: ReadonlyArray<ConsumptionCsvGroupBy> =
    CONSUMPTION_GROUP_BY_DIMENSIONS_BY_STORAGE_TYPE[data.storage_type];

  return {
    nonce: data.nonce,
    partition_group_by_result: Object.fromEntries(
      groupBys.map((groupBy) => [
        groupBy,
        months.map((month) => ({
          date: month.date.toFormat("yyyy-MM-dd"),
          top: (month.rows[groupBy] ?? []).map((row) =>
            toTourConsumptionTopItem({ row, groupBy }),
          ),
          remaining: null,
        })),
      ]),
    ),
    entire_period_group_by_result: Object.fromEntries(
      groupBys.map((groupBy) => [
        groupBy,
        {
          top: aggregateTourConsumptionPeriod({ months, groupBy }).map((row) =>
            toTourConsumptionTopItem({ row, groupBy }),
          ),
          remaining: null,
        },
      ]),
    ),
  };
};

export default tourConsumptionGetDashboardData;
